<template>
  <div>
    <Header modeType="2" />
    <div class="content-center">
      <div class="banner">
        <div class="content">
          <div class="banner-title">B2b渠道电商</div>
          <div class="line" />
          <div class="desc">
            打通各级经销商间交易流，实现多级经销渠道统一管理， 提高企业经营管理效率
            <!-- <div class="desc-content">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div> -->
          </div>
          <div class="btn-wrap">
            <div
                class="btn1"
                @click="openLoginModal"
              >免费试用</div>
            <div class="btn" @click="openModal">立即咨询</div>
          </div>
        </div>
      </div>
      
      <div class="improve1 " style="height:484px;background-color: #F8F9FB;">
          <div class="sk-block-title1">
              <div class="title1">解决行业4大痛点</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content1">
  
          </div>
      </div>
      <div class="improve" style="height:734px;">
          <div class="sk-block-title1">
              <div class="title1">打通厂商/品牌商和下游各级经销渠道<br/>交易流，实现各经销渠道明确可控</div>
              <!-- <div class="sub-title1">消费市场的习惯与供需变化，对零售门店的经营增长呈现巨大压力</div> -->
          </div>
          <div class="content1">
  
          </div>
      </div>
      
      <div class="improve1 " style="height:877px;background-color: #F3F8F8;">
          <div class="sk-block-title1">
              <div class="title1">让客户通过商城自主下单，替代业务员接单，让业务员深度做业务和服务</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content2">
            <div class="btn" @click="linkTo('QcDistribution')"></div>
          </div>
      </div>
      <div class="programme">
        <div class="sk-block-title1">
              <div class="title1" style="color: #FFFFFF;">通过大数据分析，实时了解客户需求，企业经营决策不再盲目</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content">
  
          </div>
      </div>
      <div class="improve" style="height:736px;">
          <div class="sk-block-title1">
              <div class="title1">打通渠道分销全链路交易流程，实现全流程在线化管理，提升交易效率，<br/>节约运营成本</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content2" style="margin-top: 95px;">
  
          </div>
      </div>
      <div class="custom">
      <div class="sk-block-title1">
        <div class="title1">客户案例</div>
      </div>
      <div class="content">
        <el-carousel :autoplay="false" :interval="5000" arrow="always">
          <el-carousel-item>
            <div class="custom_item">
              <img src="@/assets/images/QcB2BChannel/custom_bg1.png" alt="">
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="custom_item">
              <img src="@/assets/images/QcB2BChannel/custom_bg2.png" alt="">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
      <Contact :infoSources="'汇通数科官网-千橙B2b分销'" />
      <TryModal
        v-if="visible"
        :visible="visible"
        info-sources="社群分销"
        @cancel="modalClose"
      />
      <LoginModal
            v-if="showLogin"
            :showLogin="showLogin"
            @cancel="loginModalClose"
            :isLogin="isLogin"
            :selectValue="'8'"
        />
    </div>
    <Footer />
  </div>
  </template>
  
  <script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import metaInfo from "@/common/util/metaInfo";
  import TryModal from "@/components/TryModal";
  import Contact from "@/components/Contact";
  import LoginModal from '@/components/LoginModal'

  export default {
    metaInfo: metaInfo.QcB2BChannel,
    components: {
      Header,
      Footer,
      TryModal,
      Contact,
    LoginModal
    },
    data() {
      return {
        visible: false,
        toolBg: require("@/assets/images/QcCashier/tool1.png"),
        tooItem: "1",
        showLogin:false,//是否展示注册弹框
      isLogin:false,//是否注册
      };
    },
    mounted() {},
    methods: {
        linkTo(path) {
            if (!path.startsWith('/')) {
                path = '/' + path
            }
            this.$router.push({path})
        },
        // 是否需要显示二维码
    openLoginModal() {
        this.showLogin = true
        this.isLogin = false
    },
    loginModalClose(data) {
        this.showLogin = data;
    },
      checkBg(item) {
        this.tooItem = item;
        this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
      },
      openModal: function () {
        this.visible = true;
      },
      modalClose: function (data) {
        this.visible = data;
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .programme{
        height:745px;
        background: #202239;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content{
          margin-top:140px;
          width: 1200px;
          height:445px;
          background: url("~@/assets/images/QcB2BChannel/content4.png") no-repeat center;
          background-size: 1200px 445px;
      }
  }
  .improve1{
    background: #F8FCFF;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content1{
          margin-top:51px;
          width: 1200px;
          height:255px;
          background: url("~@/assets/images/QcB2BChannel/content1.png") no-repeat;
          background-size: 1200px 255px;
      }
      .content2{
          margin-top:50px;
          width: 1200px;
          height:680px;
          background: url("~@/assets/images/QcB2BChannel/content3.png") no-repeat;
          background-size: 1200px 680px;
          position: relative;
          .btn{
            width: 150px;
            height: 43px;
            position: absolute;
            left: 525px;
            bottom: 40px;
            cursor: pointer;
          }
      }
  }
  .improve{
      display: flex;
      flex-direction: column;
      // justify-content: center;
        background: #FFFFFF;
      align-items:center;
      .content1{
          margin-top:102px;
          width: 1200px;
          height:494px;
          background: url("~@/assets/images/QcB2BChannel/content2.png") no-repeat center;
          background-size: 1200px 494px;
      }
      .content2{
          margin-top:35px;
          width: 1200px;
          height:490px;
          background: url("~@/assets/images/QcB2BChannel/content5.png") no-repeat center;
          background-size: 1200px 490px;
      }
  }
  
  /deep/ i.el-icon-arrow-left {
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ i.el-icon-arrow-right{
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  
  .custom{
    height:662px;
        background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items:center;
    .content{
        width: 1200px;
        height:439px;
        margin: 0 auto;
        // padding: 53px 0;
        text-align: left;
        background: rgba(255,255,255,.5);
        // background: #FFFFFF;
        // opacity: 0.55;
        // border-radius: 8px;
        margin-top: 42px;
        /deep/ .el-carousel__container {
            position: relative;
            height: 439px;
        }
        .custom_item{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding:0 150px;
            img{
                width: 1200px;
                height: 439px;
            }
        }
    }
}
  .case{
      background: #F8FBFF;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
              width: 1171px;
              height:397px;
          }
      }
  }
  
    .banner {
      background: url("~@/assets/images/QcB2BChannel/banner.png") no-repeat center;
      background-size: 100% 100%;
      min-width: 1200px;
      min-height:420px;
      .content {
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        text-align: left;
        .banner-title {
          font-size: 48px;
          color: #FFFFFF;
          line-height: 55px;
        }
        .line {
          width: 100px;
          height: 6px;
          background: #28DAFB;
          margin: 16px 0 31px;
        }
        .desc {
            width: 484px;
            height: 84px;
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 28px;
          .desc-content{
              width: 600px;
              height: 96px;
              font-size: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 32px;
          }
        }
        .btn-wrap {
          display: flex;
          .btn {
            width: 200px;
            height: 58px;
            line-height: 58px;
            border-radius: 6px;
            border: 1px solid #FFFFFF;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
            margin-left:20px;
          }
          .btn1 {
            width: 200px;
            height: 58px;
            line-height: 58px;
            background: #3986FF;
            border-radius: 6px;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
          //   margin-left:20px;
          }
        }
      
    }
  
  }
  </style>
  